import { Item } from 'shared-types';
import { Rate } from '@features/rates/types';

type RateItem = Omit<Item, 'price'> & { price?: Item['price'] };

const toPayablePrice = (rate: Rate): Item['price'] | undefined =>
  rate.discount ? { ...rate.price, ...rate.discount.discountedPrice } : rate.price ?? undefined;

export function mapRateToItem(rate: Rate): RateItem {
  return {
    id: rate.id,
    name: rate.title,
    image: { url: rate.imageUrl ?? '', externalKey: '' },
    price: toPayablePrice(rate),
  };
}
